/* Bezalel — site-wide 18+ age gate. Rationale + the 7 SEO rules:
 * `reference/age-gate-spec.md`, `projects/seo-parity-2026-08-14.md` §0.
 * ⚠️ Out of theme.js on purpose — a compliance control must not be takeable down
 *    by an unrelated animation throwing, and it has a 2 KB budget. No deps.
 * ⚠️ Only ADDS a fixed layer + toggles attributes. Never removes/hides/rewrites
 *    content, never redirects a crawler, never branches on user agent.
 * ⚠️ Fail-open three deep: <noscript>; the layout watchdog (file never inits);
 *    the try/catch below (it throws after). Never traps a visitor.
 */
(function () {
  "use strict";

  var KEY = "ageConfirmed";
  var gate = document.getElementById("age-gate");
  if (!gate) return;
  gate.dataset.ready = "1";                       // cancels the layout watchdog

  var root = document.documentElement;
  var body = document.body;

  /* `inert` on every direct child of <body> bar the gate is what actually keeps Tab,
     clicks and the AT cursor out of the page behind the veil.
     ⚠️ The skip link is INCLUDED on purpose — it sits at z-index 200 and would
     otherwise be the one tabbable control outside the gate, i.e. a keyboard bypass.
     ⚠️ Tag what WE hid (`data-ag`) so unlocking cannot strip aria-hidden from the
     decorative layers born with it (.grain, .thread, .vignette…). */
  function walk(fn) {
    var kids = body.children;
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (el === gate || el.tagName === "SCRIPT") continue;
      fn(el);
    }
  }

  /* ⚠️ Lenis scrolls the document itself, so the body class alone does not hold the
     page (build-conventions §1.5). It boots from theme.js, which can land either
     side of this file — hence the guard, not an assumption. */
  function unlock() {
    body.classList.remove("age-gate-active");
    walk(function (el) {
      el.removeAttribute("inert");
      if (el.hasAttribute("data-ag")) { el.removeAttribute("aria-hidden"); el.removeAttribute("data-ag"); }
    });
    try { if (window.__lenis) window.__lenis.start(); } catch (e) {}
  }

  function drop() { if (gate.parentNode) gate.parentNode.removeChild(gate); }

  function dismiss() {
    try { localStorage.setItem(KEY, "true"); } catch (e) {}
    root.classList.add("age-ok");
    unlock();
    gate.classList.add("age-gate--leaving");
    /* transitionend can silently never fire (reduced motion, display swap), so the
       timeout is the authority and the event is only the fast path. */
    gate.addEventListener("transitionend", drop, { once: true });
    setTimeout(drop, 600);
  }

  try {
    var seen = false;
    try { seen = localStorage.getItem(KEY) === "true"; } catch (e) {}

    /* Returning visitor: <html>.age-ok was set by the layout's head primer before
       first paint, so nothing has flashed. Just take the node out. */
    if (seen) { drop(); return; }

    body.classList.add("age-gate-active");
    walk(function (el) {
      el.setAttribute("inert", "");
      if (!el.hasAttribute("aria-hidden")) { el.setAttribute("aria-hidden", "true"); el.setAttribute("data-ag", ""); }
    });
    try { if (window.__lenis) window.__lenis.stop(); } catch (e) {}

    var yes = gate.querySelector("[data-age-yes]");
    var no = gate.querySelector("[data-age-no]");

    if (yes) yes.addEventListener("click", dismiss);
    /* ⚠️ Focus the DIALOG, not the Yes button. Focusing a button here makes Chrome
       match `:focus-visible`, which painted a gold ring around Yes for mouse users
       too (browser-tested 16 Aug). The gate carries `tabindex="-1"` for this. */
    try { gate.focus({ preventScroll: true }); } catch (e) {}
    if (no) {
      no.addEventListener("click", function () {
        var url = gate.getAttribute("data-exit") || "https://aware.org.za/";
        /* ⚠️ replace(), not href — the estate must not sit one Back tap away from
           someone who has just told us they are under 18. */
        try { location.replace(url); } catch (e) { location.href = url; }
      });
    }
    /* ⚠️ Late-injected app embeds (Shopify Inbox…) are added to <body> after the
       walk above, so they never get `inert` — covered by the veil, but still
       Tab-reachable. This pulls focus back and is the only guard against that.
       ⚠️ No Escape handler, unlike the cart drawer and the lightbox. A legal
       control cannot ship a keyboard bypass. */
    document.addEventListener("focusin", function (e) {
      if (gate.isConnected && !gate.contains(e.target) && yes) yes.focus();
    });
  } catch (err) {
    try { root.classList.add("age-ok"); unlock(); drop(); } catch (e) {}
  }
})();
